import { DataTable } from "@/components/data-table";
import { useGetAllArticuloHistorialesQuery } from "../api/get-articulo-historiales";
import { ArticuloHistorialTipo } from "@/shared/types/articulo-historial";
import { Stack, StackProps } from "@mui/material";
import { formatDate, formatNumber, formatString } from "@/shared/formats";
import { useFilters } from "@/components/filters";
import { Form, useForm } from "@/components/form";
import { getDeposito } from "../../depositos/api/get-deposito";
import { getAllDepositos } from "../../depositos/api/get-all-depositos";

interface ViewArticuloHistorialProps extends StackProps {
    articuloId: string
}

export default function ViewArticuloHistorial({
    articuloId,
    ...props
}: ViewArticuloHistorialProps) {
    const renderTipoHistorial = (tipo: ArticuloHistorialTipo) => {
        switch (tipo) {
            case ArticuloHistorialTipo.Creacion: return "Creación";
            case ArticuloHistorialTipo.Modificacion: return "Modificación";
            case ArticuloHistorialTipo.Eliminacion: return "Eliminación";
            case ArticuloHistorialTipo.Compra: return "Compra";
            case ArticuloHistorialTipo.AnulacionCompra: return "Anulación de Compra";
            case ArticuloHistorialTipo.Venta: return "Venta";
            case ArticuloHistorialTipo.AnulacionVenta: return "Anulación de Venta";
            case ArticuloHistorialTipo.Envio: return "Envío";
            case ArticuloHistorialTipo.AnulacionEnvio: return "Anulación de Envío";
            case ArticuloHistorialTipo.Recepcion: return "Recepción";
            case ArticuloHistorialTipo.AnulacionRecepcion: return "Anulación de Recepción";
            case ArticuloHistorialTipo.Entrada: return "Entrada";
            case ArticuloHistorialTipo.AnulacionEntrada: return "Anulación de Entrada";
            case ArticuloHistorialTipo.Salida: return "Salida";
            case ArticuloHistorialTipo.AnulacionSalida: return "Anulación de Salida";
        }
    }

    const filterData = useFilters({
        filters: [
            { type: "dateRange", fromName: "desde", toName: "hasta", label: "Fecha" },
            { type: "model", name: "depositoId", label: "Depósito", get: getDeposito, getAll: getAllDepositos },
            // { type: "select", name: "tipo", label: "Tipo", options: Object.values(ArticuloHistorialTipo).map(v => ({ label: renderTipoHistorial(v as ArticuloHistorialTipo), value: v })) },
            { type: "pagination" }
        ],
        useURL: false
    })

    const fetchData = useGetAllArticuloHistorialesQuery(articuloId, filterData.filterData);

    const form = useForm({
        onSubmit: ({ value }) => {
            filterData.setFilterData({ ...filterData.filterData, ...value, page: 0 });
        },
        defaultValues: {
            desde: "",
            hasta: "",
            depositoId: ""
        },
        submitOnce:false,
        closeModalOnSubmit:false,
    })

    return <Stack gap={3} {...props}>
        <Form form={form} direction={"row"} gap={2}>
            <Form.DatePicker name="desde" label="Desde" size="small" clearable />
            <Form.DatePicker name="hasta" label="Hasta" size="small" displayDateOffset={-1} clearable />
            <Stack minWidth={"250px"}>
                <Form.ModelComboBox name="depositoId" label="Depósito" get={getDeposito} getAll={getAllDepositos} size="small" />
            </Stack>
            <Form.SubmitButton>Filtrar</Form.SubmitButton>
        </Form>
        <DataTable minHeight={"400px"}>
            <DataTable.Content
                fit="flex"
                loading={fetchData.isFetching}
                rows={fetchData.data?.result}
                columns={[
                    { header: "Fecha", render: row => formatDate(row.fecha, true), width: "auto" },
                    { header: "Acción", render: row => renderTipoHistorial(row.tipo), width: "auto" },
                    { header: "Depósito", render: row => formatString(row.depositoNombre), width: "auto" },
                    { header: "Usuario", render: row => formatString(row.usuarioNombre) },
                    { header: "Cantidad Inicial", render: row => formatNumber(row.cantidadInicial), align: "right", width: "auto" },
                    { header: "Cantidad Modificada", render: row => formatNumber(row.cantidad), align: "right", width: "auto" },
                    { header: "Cantidad Final", render: row => formatNumber(row.cantidadFinal), align: "right", width: "auto" },
                ]}
            />
            <DataTable.Pagination queryResult={fetchData} filterData={filterData} />
        </DataTable>
    </Stack>
}